import { render, staticRenderFns } from "./SettingsStagePointsForLose.vue?vue&type=template&id=41d684b3&"
import script from "./SettingsStagePointsForLose.vue?vue&type=script&lang=js&"
export * from "./SettingsStagePointsForLose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports